import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Text from 'components/base/Text';
import { Flex, Margin } from 'components/base/layout-components';
import styled from 'styled-components';

const Wrapper = styled(Flex)`
  padding: 3rem;
  align-items: center;
  justify-content: center;
`;
const ConfirmationDialog = ({
  title,
  image,
  content,
  confirmText,
  cancelText,
  isOpen,
  cancelButtonType = 'contained',
  onCancel,
  okButtonType = 'outlined',
  onConfirm,
  justifyButtons = 'center'
}) => (
  <Dialog open={isOpen}>
    <Wrapper>
      {image && <img src={image} alt='' />}
      <Flex pl={image ? 'medium' : ''} direction='column'>
        <Text color='shark' size='x-x-large' weight='500'>
          {title}
        </Text>
        <Flex pt='medium' pb='medium'>
          {content}
        </Flex>
        <Flex justify={image ? 'flex-start' : justifyButtons}>
          <Button
            data-cy='confirmation-dialog-cancel'
            onClick={onCancel}
            variant={cancelButtonType}
          >
            {cancelText}
          </Button>
          <Margin r='small' />
          <Button
            data-cy='confirmation-dialog-ok'
            onClick={onConfirm}
            variant={okButtonType}
          >
            {confirmText}
          </Button>
        </Flex>
      </Flex>
    </Wrapper>
  </Dialog>
);

export default ConfirmationDialog;
